// extracted by mini-css-extract-plugin
module.exports = {"section":"section-module--section--1J_qP"};